export function dayofweekCheck(value, manipulatedDate) {
    //Check dayofweek field
    if (value.dayofweek === "*" || value.dayofweek === "?") {
        return true;
    }
    if (typeof value.DELIMITER_DOW !== "undefined") {
        const dayofweekarr = value.dayofweek.split(value.DELIMITER_DOW);
        const dayofweekisincluded = dayofweekarr.includes(value.getDayOfWeekAbbreviation([manipulatedDate.weekday()], "string", undefined, ","));
        if (value.DELIMITER_DOW === "/") {
            //Day is start and interval
            // Normalize to number of days in month cycle
            const offset = (manipulatedDate.weekday() -
                parseInt(dayofweekarr[0]) +
                manipulatedDate.weekday()) %
                manipulatedDate.weekday();
            // Check divisibility
            return offset % parseInt(dayofweekarr[1]) === 0;
        }
        //Day is comma separated list
        // value.DELIMITER_DOW === "," &&
        if (dayofweekisincluded) {
            return true;
        }
    }
    //value could be a single day (MON, TUE, WED, THU, FRI, SAT, SUN)
    const currentDayAbbr = value.getDayOfWeekAbbreviation([manipulatedDate.weekday()], "string", undefined, ",");
    if (currentDayAbbr === value.dayofweek) {
        return true;
    }
    return false;
}
//# sourceMappingURL=dayofweekCheck.js.map